


















import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';


@Component({
  name: 'JobWorkerStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: JobWorkerStatus;

	get shortlisted() {
		return this.hasStatus(JobWorkerStatus.Shortlisted);
	}

	get sentToWorker() {
		return this.hasStatus(JobWorkerStatus.SentToWorker);
	}

	get sentToContact() {
		return this.hasStatus(JobWorkerStatus.SentToContact);
	}

	get workerInterested() {
		return this.hasStatus(JobWorkerStatus.WorkerInterested);
	}

	get workerNotInterested() {
		return this.hasStatus(JobWorkerStatus.WorkerNotInterested);
	}

	get contactInterested() {
		return this.hasStatus(JobWorkerStatus.ContactInterested);
	}

	get contactNotInterested() {
		return this.hasStatus(JobWorkerStatus.ContactNotInterested);
	}

	get interviewOne() {
		return this.hasStatus(JobWorkerStatus.InterviewOne);
	}

	get interviewTwo() {
		return this.hasStatus(JobWorkerStatus.InterviewTwo);
	}

	get offer() {
		return this.hasStatus(JobWorkerStatus.Offer);
	}

	get accepted() {
		return this.hasStatus(JobWorkerStatus.Accepted);
	}

	get placed() {
		return this.hasStatus(JobWorkerStatus.Placed);
	}

	get rejected() {
		return this.hasStatus(JobWorkerStatus.Rejected);
	}

	hasStatus(status: JobWorkerStatus) {
		if (this.status === status) {
			return true
		}
		return false;
	}
}
